import React from "react";
import { Link } from "react-router-dom";

const DashBoardSideBar = () => {
  return (
    <div style={{ backgroundColor: "#050B20" }} className="side-bar">
      <ul className="nav-list">
        <li>
          <Link to="/DashBoard">
            <img src="images/icons/dash1.svg"   />
            Dashboard
          </Link>
        </li>
        <li>
          <Link to="/Listing">
            <img src="images/icons/dash2.svg"   />
            My Listings
          </Link>
        </li>
        <li>
          <Link to="/AddListing">
            <img src="images/icons/dash3.svg"   />
            Add Listings
          </Link>
        </li>
        <li>
          <Link to="/MyProfile">
            <img src="images/icons/dash7.svg"   />
            My Profile
          </Link>
        </li>
        <li>
          <Link to="/">
            <img src="images/icons/dash8.svg"   />
            Logout
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default DashBoardSideBar;
